import { IFullWidthMedia } from '@models/IFullWidthMedia';
import SharedFullWidthMedia from '@molecules/FullWidthMedia/FullWidthMedia';

const FullWidthMedia = (props: IFullWidthMedia) => (
  <SharedFullWidthMedia {...props} />
);

export default FullWidthMedia;
